import styled from 'styled-components'
import { AgentColorPallette } from '../../configs/colorPallete'

export const CustomButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: ${(props) => props.padLt || '0'};
  padding-right: ${(props) => props.padRt || '0'};
  padding-top: ${(props) => props.padTop || '12px'};
  padding-bottom: ${(props) => props.padBtm || '12px'};
  border-radius: ${(props) => props.borderRadius || '24px'};
  font-weight: 800;
  font-size: ${(props) => props.fontSize || '14px'};
  cursor: pointer;
  width: ${(props) => props.width || '100%'};
  border: ${(props) => props.border || 'none'};
  color: ${(props) => props.textColor || AgentColorPallette.fontDarkGrey};
  background-color: ${(props) => props.backgroundColor || AgentColorPallette.primary};
  text-transform: uppercase;
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: ${(props) => props.theme.fontSemiGrey};
    color: ${(props) => props.theme.white};
  }
`

export const FilledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: ${(props) => props.width || '100%'};
  height: 40px;
  background: ${AgentColorPallette.primary};
  border: 2px solid ${AgentColorPallette.primary};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 800;
  color: ${AgentColorPallette.darkCharcoal};
  cursor: pointer;
  outline: none;

  ${(props) =>
    props.disabled &&
    `
    background: ${AgentColorPallette.grey_eee};
    border: 2px solid ${AgentColorPallette.grey_eee};
    color: ${AgentColorPallette.darkCharcoal};
  `}

  ${(props) =>
    props.loading &&
    `
    background: transparent;
    border: 2px solid transparent;
  `}
`

export const FilledButtonBlue = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: ${(props) => props.width || '100%'};
  height: 40px;
  background: ${AgentColorPallette.ppBlue};
  border: 2px solid ${AgentColorPallette.ppBlue};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 800;
  color: ${AgentColorPallette.white};
  cursor: pointer;
  outline: none;

  ${(props) =>
    props.disabled &&
    `
    background: ${AgentColorPallette.grey_eee};
    border: 2px solid ${AgentColorPallette.grey_eee};
    color: ${AgentColorPallette.darkCharcoal};
  `}

  ${(props) =>
    props.loading &&
    `
    background: transparent;
    border: 2px solid transparent;
  `}
`

export const OutlinedButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: ${(props) => props.width || '100%'};
  height: 40px;
  background: ${AgentColorPallette.white};
  border: 2px solid ${AgentColorPallette.primary};
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 12px;
  font-weight: 800;
  color: ${AgentColorPallette.darkCharcoal};
  cursor: pointer;
  outline: none;

  ${(props) =>
    props.disabled &&
    `
    background: ${AgentColorPallette.white};
    border: 2px solid ${AgentColorPallette.grey_eee};
    color: ${AgentColorPallette.darkCharcoal};
  `}

  ${(props) =>
    props.loading &&
    `
    background: transparent;
    border: 2px solid transparent;
  `}
`
